import { __awaiter, __generator } from "tslib";
import { _Folder, } from "../folders/types.js";
import { SharingRole, } from "./types.js";
_Folder.prototype.shareWith = function (loginNames, role, requireSignin, shareEverything, emailData) {
    if (role === void 0) { role = SharingRole.View; }
    if (requireSignin === void 0) { requireSignin = false; }
    if (shareEverything === void 0) { shareEverything = false; }
    return __awaiter(this, void 0, void 0, function () {
        var dependency, shareable;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dependency = this.addBatchDependency();
                    return [4 /*yield*/, this.getShareable()];
                case 1:
                    shareable = _a.sent();
                    dependency();
                    return [2 /*return*/, shareable.shareWith(loginNames, role, requireSignin, shareEverything, emailData)];
            }
        });
    });
};
_Folder.prototype.getShareLink = function (kind, expiration) {
    if (expiration === void 0) { expiration = null; }
    return __awaiter(this, void 0, void 0, function () {
        var dependency, shareable;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dependency = this.addBatchDependency();
                    return [4 /*yield*/, this.getShareable()];
                case 1:
                    shareable = _a.sent();
                    dependency();
                    return [2 /*return*/, shareable.getShareLink(kind, expiration)];
            }
        });
    });
};
_Folder.prototype.checkSharingPermissions = function (recipients) {
    return __awaiter(this, void 0, void 0, function () {
        var dependency, shareable;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dependency = this.addBatchDependency();
                    return [4 /*yield*/, this.getShareable()];
                case 1:
                    shareable = _a.sent();
                    dependency();
                    return [2 /*return*/, shareable.checkSharingPermissions(recipients)];
            }
        });
    });
};
_Folder.prototype.getSharingInformation = function (request, expands) {
    return __awaiter(this, void 0, void 0, function () {
        var dependency, shareable;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dependency = this.addBatchDependency();
                    return [4 /*yield*/, this.getShareable()];
                case 1:
                    shareable = _a.sent();
                    dependency();
                    return [2 /*return*/, shareable.getSharingInformation(request, expands)];
            }
        });
    });
};
_Folder.prototype.getObjectSharingSettings = function (useSimplifiedRoles) {
    if (useSimplifiedRoles === void 0) { useSimplifiedRoles = true; }
    return __awaiter(this, void 0, void 0, function () {
        var dependency, shareable;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dependency = this.addBatchDependency();
                    return [4 /*yield*/, this.getShareable()];
                case 1:
                    shareable = _a.sent();
                    dependency();
                    return [2 /*return*/, shareable.getObjectSharingSettings(useSimplifiedRoles)];
            }
        });
    });
};
_Folder.prototype.unshare = function () {
    return __awaiter(this, void 0, void 0, function () {
        var dependency, shareable;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dependency = this.addBatchDependency();
                    return [4 /*yield*/, this.getShareable()];
                case 1:
                    shareable = _a.sent();
                    dependency();
                    return [2 /*return*/, shareable.unshare()];
            }
        });
    });
};
_Folder.prototype.deleteSharingLinkByKind = function (kind) {
    return __awaiter(this, void 0, void 0, function () {
        var dependency, shareable;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dependency = this.addBatchDependency();
                    return [4 /*yield*/, this.getShareable()];
                case 1:
                    shareable = _a.sent();
                    dependency();
                    return [2 /*return*/, shareable.deleteSharingLinkByKind(kind)];
            }
        });
    });
};
_Folder.prototype.unshareLink = function (kind, shareId) {
    return __awaiter(this, void 0, void 0, function () {
        var dependency, shareable;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dependency = this.addBatchDependency();
                    return [4 /*yield*/, this.getShareable()];
                case 1:
                    shareable = _a.sent();
                    dependency();
                    return [2 /*return*/, shareable.unshareLink(kind, shareId)];
            }
        });
    });
};
//# sourceMappingURL=folder.js.map